import React, { useState } from "react";
import Dashboard from "./components/Dashboard";
import StoryDetails from "./components/StoryDetails";

const Workspace = () => {
  const [selectedStoryId, setSelectedStoryId] = useState(null);
  return (
    <>
      {!selectedStoryId ? (
        <Dashboard onSelectStory={setSelectedStoryId} />
      ) : (
        <StoryDetails
          storyId={selectedStoryId}
          onBack={() => setSelectedStoryId(null)}
        />
      )}
    </>
  );
};

export default Workspace;
